import { ContentCollectionHorizontal } from "contentCollection";
import { Id, config, content } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import { isCardFixed } from "pages/utils";
import React from "react";
function isCompatible(homepage) {
    return homepage.tickets.length > 0;
}
export var block = function (data) {
    if (!isCompatible(data))
        return Option.none;
    return Option.some({
        key: "tickets",
        View: function () { return (React.createElement(ContentCollectionHorizontal, { componentId: Id.component.contentCollection.ticketsCollection, listName: config.tracking.listNames.tickets, title: content.tickets.blockTitle, items: data.tickets.filter(isCardFixed), trackingEnabled: !data.fetchingData, callToAction: {
                url: "/doe-mee",
                title: "Naar alle tickets & deelnames",
            } })); },
    });
};
